import React from 'react';
import { JdsTag } from '../../../../../../components/jds/JdsTag';

export const InfoCard = ({ title, text, active }) => (
  <div className="jds-card" style={{ padding: 'var(--space-24)' }}>
    <div className="d-flex justify-content-between align-items-center">
      <span className="text-muted">{title}</span>
      {active !== undefined && (
        <JdsTag
          dot
          label={active ? 'Ativo' : 'Inativo'}
          color={active ? 'success' : 'error'}
        />
      )}
    </div>
    <p className="jds-title-sm" style={{ marginTop: 'var(--space-4)' }}>
      {text}
    </p>
  </div>
);
